module.exports = __webpack_public_path__ + "img/liam_eichenberg.03fe6123.png";